import { atom } from "jotai";
import moment from "moment";

import DaysServices from "utils/days";

/** Тип открытого раздела документов (операция из DocumentsOperations) */
export const selectedDocumentTypeAtom = atom(null);

/** Шаблоны печати для текущего типа документа */
export const selectedDocumentTypeTemplatesAtom = atom([]);

export const documentsFiltersInit = () => ({
  page: 1,
  pageSize: 1000,
  dateFrom: DaysServices.getDayStart(moment().subtract(1, "month").toDate()),
  dateTo: DaysServices.getDayEnd(new Date()),
});

export const documentsFiltersAtom = atom(documentsFiltersInit());

/** Список документов (сырые данные с сервера) */
export const documentsAtom = atom([]);

/** Выделенный (один клик) документ в списке */
export const selectedDocumentAtom = atom(null);

/** Открытый (в модалке) документ */
export const openedDocumentAtom = atom(null);

/** Редактируемая шапка открытого документа */
export const openedDocumentStateAtom = atom({});

/** Позиции открытого документа (с локальными флагами isNew/isEdited) */
export const docItemsAtom = atom([]);

/** Загрузка позиций открытого документа */
export const docItemsLoadingAtom = atom(false);

export const selectedDocItemAtom = atom(null);

/** Открытая (в модалке 2 уровня) позиция */
export const openedDocItemAtom = atom(null);

/** Редактируемое состояние позиции */
export const openedDocItemStateAtom = atom({});

/** Позиции, помеченные на удаление (существующие на сервере) */
export const docItemsToDeleteAtom = atom([]);
